import React from 'react';
import { Lock, Crown, X, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { Button } from './ui/button';

const PaywallModal = ({ isOpen, onClose, promptTitle }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="bg-[#1a1a2e] border-gray-800 text-white max-w-md">
        <DialogHeader>
          <DialogTitle className="text-center">
            <div className="flex flex-col items-center">
              <div className="w-20 h-20 rounded-full bg-gradient-to-br from-yellow-500 to-orange-500 flex items-center justify-center mb-4">
                <Lock size={40} className="text-white" />
              </div>
              <h2 className="text-2xl font-bold text-white">Premium Content</h2>
            </div>
          </DialogTitle>
        </DialogHeader>
        
        <div className="text-center py-4">
          <p className="text-gray-400 mb-2">This prompt is locked:</p>
          <p className="text-white font-semibold text-lg mb-6">"{promptTitle}"</p>
          
          <div className="bg-gradient-to-r from-purple-900/50 to-orange-900/50 rounded-xl p-4 mb-6">
            <div className="flex items-center justify-center gap-2 mb-3">
              <Crown size={20} className="text-yellow-400" />
              <span className="text-yellow-400 font-semibold">Upgrade to Premium</span>
            </div>
            <p className="text-gray-300 text-sm">
              Get unlimited access to all prompts, AI tools, and exclusive content.
            </p>
          </div>

          <div className="space-y-3">
            <Link to="/credits" onClick={onClose}>
              <Button className="w-full bg-gradient-to-r from-purple-600 to-orange-500 hover:from-purple-700 hover:to-orange-600 text-white py-6">
                <Sparkles size={18} className="mr-2" />
                Upgrade Now
              </Button>
            </Link>
            <Button
              variant="outline"
              onClick={onClose}
              className="w-full border-gray-700 text-gray-400 hover:bg-gray-800 hover:text-white"
            >
              Maybe Later
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PaywallModal;
